module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "coupon-base"
  }, [_c('h3', [_vm._v("优惠券基本信息")]), _vm._v(" "), _c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.formLoading),
      expression: "formLoading"
    }],
    ref: "couponFormRef",
    attrs: {
      "model": _vm.couponInfo,
      "inline": true,
      "rules": _vm.couponInfoRules
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 10,
      "offset": 2
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "优惠券名称:",
      "prop": "title"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.couponInfo.title),
      callback: function($$v) {
        _vm.$set(_vm.couponInfo, "title", $$v)
      },
      expression: "couponInfo.title"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10,
      "offset": 2
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "优惠券类型:",
      "prop": "type"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.couponInfo.type),
      callback: function($$v) {
        _vm.$set(_vm.couponInfo, "type", $$v)
      },
      expression: "couponInfo.type"
    }
  }, _vm._l((_vm.couponTypeOptions), function(item) {
    return _c('el-option', {
      key: Number(item.value),
      attrs: {
        "label": item.label,
        "value": Number(item.value),
        "default-first-option": ""
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10,
      "offset": 2
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "领取方式:",
      "prop": "receiveType"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.couponInfo.receiveType),
      callback: function($$v) {
        _vm.$set(_vm.couponInfo, "receiveType", $$v)
      },
      expression: "couponInfo.receiveType"
    }
  }, _vm._l((_vm.couponReceiveTypeOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "explain"
  }, [_vm._v("\n              系统赠送: 相关活动赠送\n              "), _c('br'), _vm._v("\n              新用户注册: 会员注册后,自动赠送\n              "), _c('br'), _vm._v("\n              用户推广: 会员推广成功后(新用户注册),自动赠送\n              "), _c('br'), _vm._v("\n              优惠券兑换: 相关优惠Code兑换\n              "), _c('br'), _vm._v("\n              用户领取: 用户主动领取\n            ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10,
      "offset": 2
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "有效期类型:",
      "prop": "validityType"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.couponInfo.validityType),
      callback: function($$v) {
        _vm.$set(_vm.couponInfo, "validityType", $$v)
      },
      expression: "couponInfo.validityType"
    }
  }, _vm._l((_vm.couponValidityTypeOptions), function(item) {
    return _c('el-option', {
      key: Number(item.value),
      attrs: {
        "label": item.label,
        "value": Number(item.value)
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "explain"
  }, [_vm._v("\n              固定时: 优惠券Code与当前有效期保持一致\n              "), _c('br'), _vm._v("\n              领取后N天有效: 优惠券Code在领取后N天后有效\n              "), _c('br'), _vm._v("\n              长期有效: 优惠券Code永久有效\n            ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10,
      "offset": 2
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "消费方式:",
      "prop": "consumeType"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.couponInfo.consumeType),
      callback: function($$v) {
        _vm.$set(_vm.couponInfo, "consumeType", $$v)
      },
      expression: "couponInfo.consumeType"
    }
  }, _vm._l((_vm.couponConsumeTypeOptions), function(item) {
    return _c('el-option', {
      key: Number(item.value),
      attrs: {
        "label": item.label,
        "value": Number(item.value)
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "explain"
  }, [_vm._v("\n              线上核销: 指用户在下单时使用优惠券进行线上核销\n              "), _c('br'), _vm._v("\n              线下核销\n              指用户到店后，出示二维码或者出示串码，由收银员完成核销动作，如扫码核销、机具核销等。\n            ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10,
      "offset": 2
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "优惠券面额:",
      "prop": "amount"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 2,
      "min": 0,
      "controls-position": "right"
    },
    model: {
      value: (_vm.couponInfo.amount),
      callback: function($$v) {
        _vm.$set(_vm.couponInfo, "amount", $$v)
      },
      expression: "couponInfo.amount"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "explain"
  }, [_vm._v("\n              满减券: 订单金额满足最低消费，则为减免金额。\n              "), _c('br'), _vm._v("\n              代金券: 直接为减免金额\n            ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10,
      "offset": 2
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "优惠券折扣:"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 2,
      "max": 1,
      "min": 0,
      "controls-position": "right"
    },
    model: {
      value: (_vm.couponInfo.discount),
      callback: function($$v) {
        _vm.$set(_vm.couponInfo, "discount", $$v)
      },
      expression: "couponInfo.discount"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "explain"
  }, [_vm._v("\n              折扣券: 0.8=8折,计算方式: 订单总额*折扣 100*(1-0.8)\n            ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10,
      "offset": 2
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "券折扣上限:"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 2,
      "min": -1,
      "controls-position": "right"
    },
    model: {
      value: (_vm.couponInfo.discountLimit),
      callback: function($$v) {
        _vm.$set(_vm.couponInfo, "discountLimit", $$v)
      },
      expression: "couponInfo.discountLimit"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "explain"
  }, [_vm._v("\n              表示最多允许折扣多少,与`优惠券折扣`相关，如果不填或者小于等于零，则默认为无限制\n            ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10,
      "offset": 2
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "最低消费:"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 2,
      "min": 0,
      "controls-position": "right"
    },
    model: {
      value: (_vm.couponInfo.minCost),
      callback: function($$v) {
        _vm.$set(_vm.couponInfo, "minCost", $$v)
      },
      expression: "couponInfo.minCost"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "explain"
  }, [_vm._v("\n              只有金额满足最低消费才能使用\n            ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10,
      "offset": 2
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "有效期天数:"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "controls-position": "right"
    },
    model: {
      value: (_vm.couponInfo.fixedTerm),
      callback: function($$v) {
        _vm.$set(_vm.couponInfo, "fixedTerm", $$v)
      },
      expression: "couponInfo.fixedTerm"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "explain"
  }, [_vm._v("\n              N天失效 = 领取时间+有效期天数\n            ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10,
      "offset": 2
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "优惠券总量:"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": -1,
      "controls-position": "right"
    },
    model: {
      value: (_vm.couponInfo.total),
      callback: function($$v) {
        _vm.$set(_vm.couponInfo, "total", $$v)
      },
      expression: "couponInfo.total"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "explain"
  }, [_vm._v("\n              如果不填或者小于等于零，则默认为无限制\n            ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10,
      "offset": 2
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "每人限领/张:",
      "prop": "maxFetch"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": -1,
      "controls-position": "right"
    },
    model: {
      value: (_vm.couponInfo.maxFetch),
      callback: function($$v) {
        _vm.$set(_vm.couponInfo, "maxFetch", $$v)
      },
      expression: "couponInfo.maxFetch"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "explain"
  }, [_vm._v("\n              如果不填或者小于等于零，则默认为无限制\n            ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8,
      "offset": 2
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "有效期开始时间:",
      "prop": "startTime"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "picker-options": _vm.pickerOptions,
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.couponInfo.startTime),
      callback: function($$v) {
        _vm.$set(_vm.couponInfo, "startTime", $$v)
      },
      expression: "couponInfo.startTime"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8,
      "offset": 2
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "有效期结束时间:",
      "prop": "endTime"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "picker-options": _vm.pickerOptions,
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.couponInfo.endTime),
      callback: function($$v) {
        _vm.$set(_vm.couponInfo, "endTime", $$v)
      },
      expression: "couponInfo.endTime"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8,
      "offset": 2
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "优惠券状态:",
      "prop": "status"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.couponInfo.status),
      callback: function($$v) {
        _vm.$set(_vm.couponInfo, "status", $$v)
      },
      expression: "couponInfo.status"
    }
  }, _vm._l((_vm.couponStatusOptions), function(item) {
    return _c('el-option', {
      key: Number(item.value),
      attrs: {
        "label": item.label,
        "value": Number(item.value)
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "explain"
  }, [_vm._v("\n              将配合JOB进行启动与结束\n            ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "优惠券介绍:"
    }
  }, [_c('div', {
    attrs: {
      "id": "editor"
    }
  })])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "button"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handlerSave
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "coupon-list"
  }, [_c('div', {
    staticClass: "coupon-goods"
  }, [_c('h3', [_vm._v("参与商品")]), _vm._v(" "), _c('coupon-goods', {
    attrs: {
      "coupon-id": _vm.couponInfo.id
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "coupon-goods"
  }, [_c('h3', [_vm._v("参与型号")]), _vm._v(" "), _c('coupon-model', {
    attrs: {
      "coupon-id": _vm.couponInfo.id
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "coupon-goods"
  }, [_c('h3', [_vm._v("参与品牌")]), _vm._v(" "), _c('coupon-brand', {
    attrs: {
      "coupon-id": _vm.couponInfo.id
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "coupon-goods"
  }, [_c('h3', [_vm._v("参与品类")]), _vm._v(" "), _c('coupon-category', {
    attrs: {
      "coupon-id": _vm.couponInfo.id
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-2ce5f15b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/biz/coupon/components/couponEdit.vue
// module id = 1629
// module chunks = 0